/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import { combineReducers } from 'redux';
import Auth from './Auth';
import Users from './Users';
import Assessment from './Assessment';
import Student from './Student';
import Common from './Common';
import Group from './Group';
import Imperson from './UserImperson'





const reducers = combineReducers({
  assessment: Assessment,
  auth: Auth,
  users: Users,
  student: Student,
  common: Common,
  group: Group,
  imperson: Imperson

});

export default reducers;